













import { Vue, Component } from 'vue-property-decorator'
import ChartsNav from '@/views/ChartsNav.vue'

@Component({
  components: {
    ChartsNav
  }
})
export default class Reports extends Vue {
  private route = 'ctc-total-sessions'
  private  iframe = process.env.VUE_APP_IFRAME_RECEIVE_EMIT
  public get getToken() {
    return this.$store.getters['authentication/getToken']
  }

  public receiveMessage(event) {
    if(event.origin !== process.env.VUE_APP_IFRAME_RECEIVE_EMIT) return
    this.emitMessage()
  }

  private emitMessage() {
    var targetIframe = document.getElementById('diy-iframe').contentWindow
    targetIframe.postMessage({ token: this.getToken, route: this.route }, process.env.VUE_APP_IFRAME_RECEIVE_EMIT)
  }

  private created() {
    window.addEventListener('message', this.receiveMessage)
  }
}
